import { Flex, RemoteImage } from '@banhala/ui-kit';

const IMAGE_HEIGHT = 120;

interface TwoImageHeaderProps {
  images: string[];
  cardWidth: number;
}

export const TwoImageHeader = ({ images, cardWidth }: TwoImageHeaderProps) => {
  const imageWidth = (cardWidth - 2) / 2;

  return (
    <Flex.Row height={IMAGE_HEIGHT} gap={2}>
      {images.slice(0, 2).map((uri, index) => (
        <RemoteImage
          key={index}
          uri={uri}
          width={imageWidth}
          height={IMAGE_HEIGHT}
        />
      ))}
    </Flex.Row>
  );
};
